import React from 'react';
import { getAuth } from 'firebase/auth';
import { httpsCallable } from 'firebase/functions';
import { Modal, ModalBody, Button } from 'reactstrap';
import { toast } from 'react-toastify';
import { useToggle } from 'react-use';

import firebase, { functions } from '../firebase';
const auth = getAuth(firebase);

export default function EmailVerificationModal ({ isOpen }) {
  const [isSending, toggleSending] = useToggle();
  const onClickSend = async () => {
    toggleSending();
    try {
      const resendEmailVerification = httpsCallable(functions, 'resendEmailVerification');
      await resendEmailVerification();
      toast.success('メールアドレス確認メールを送信しました');
    } catch (e) {
      toast.error('送信失敗しました');
      console.error(e);
    }
    toggleSending();
  };

  return (
    <Modal isOpen={isOpen} backdrop="static" centered>
      <ModalBody className="p-4">
        <h5 className="mb-3">メールアドレスの確認が必要です</h5>
        <p>
          ご登録いただいたメールアドレスにメールをお送りしました。
          <br />
          メール本文内のリンクをクリックして、メールアドレス確認を完了してください。
        </p>
        <p className="text-muted small mb-3">
          確認が完了すると、この画面は自動的に閉じます。
        </p>
        <div className="d-flex gap-2">
          <Button color="primary" outline onClick={onClickSend} disabled={isSending}>
            確認メールを再送信する
          </Button>
          <Button color="link" className="text-muted" onClick={_ => auth.signOut()}>
            ログアウト
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
}
